export default __webpack_public_path__ + "static/media/pressmare.b174121b.png";